export default {
  active: localStorage.getItem("theme") || "light",
};
